import React, { memo, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

import cn from 'utils/classnames';

import { ReactComponent as ArrowHeaderIcon } from 'assets/images/headerNavigation/arrow.svg';

import styles from './PlaceDropdown.module.scss';

const PlaceDropdown = ({
  myPlace,
  isLoadingGetMyPlace,
  selectedPlaceId,
  onSelectPlace,
}) => {
  const [menu, setMenu] = useState(false);

  const selectedPlace = useMemo(
    () => myPlace.find((place) => place._id === selectedPlaceId) ?? myPlace[0],
    [myPlace, selectedPlaceId],
  );

  const onToggle = useCallback(() => {
    setMenu((prevState) => !prevState);
  }, []);

  const onSelect = useCallback((placeId) => {
    onSelectPlace(placeId);
    setMenu(false);
  }, [onSelectPlace]);

  if (isLoadingGetMyPlace) {
    return <span className={styles.PlaceSelectorLoading}>...</span>;
  }

  if (!myPlace.length) {
    return null;
  }

  return (
    <Dropdown
      isOpen={menu}
      toggle={onToggle}
      className={styles.PlaceSelector}
    >
      <DropdownToggle tag="button" className={styles.PlaceSelectorToggle}>
        <span className={styles.PlaceSelectorName}>{selectedPlace?.name}</span>
        <span className={styles.PlaceSelectorArrow}>
          <ArrowHeaderIcon />
        </span>
      </DropdownToggle>

      <DropdownMenu
        end
        className={cn(styles.PlaceSelectorMenu, menu && styles.PlaceSelectorMenuOpen)}
      >
        {myPlace.map((place) => (
          <button
            key={place._id}
            type="button"
            className={cn(
              styles.PlaceSelectorItem,
              place._id === selectedPlaceId && styles.PlaceSelectorItemActive,
            )}
            onClick={() => onSelect(place._id)}
          >
            {place.name}
          </button>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

PlaceDropdown.propTypes = {
  myPlace: PropTypes.instanceOf(Array).isRequired,
  isLoadingGetMyPlace: PropTypes.bool,
  selectedPlaceId: PropTypes.string,
  onSelectPlace: PropTypes.func.isRequired,
};

PlaceDropdown.defaultProps = {
  isLoadingGetMyPlace: false,
  selectedPlaceId: '',
};

export default memo(PlaceDropdown);
